import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import asyncComponent from '../../../../../util/asyncComponent';


const SalesSupport = ({match}) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/business-type`}/>
            <Route path={`${match.url}/business-type`} component={asyncComponent(() => import('./routes/BusinessType'))}/>
            <Route path={`${match.url}/company`} component={asyncComponent(() => import('./routes/Company'))}/>
            <Route path={`${match.url}/customer`} component={asyncComponent(() => import('./routes/Customer'))}/>
            <Route path={`${match.url}/customer-status`} component={asyncComponent(() => import('./routes/CustomerStatus'))}/>
            <Route path={`${match.url}/country`} component={asyncComponent(() => import('./routes/Country'))}/>
            <Route path={`${match.url}/package-country`} component={asyncComponent(() => import('./routes/PackageCategory'))}/>
            <Route path={`${match.url}/product`} component={asyncComponent(() => import('./routes/Product'))}/>
            <Route path={`${match.url}/transportation-cost`} component={asyncComponent(() => import('./routes/TransportationCost'))}/>
            <Route component={asyncComponent(() => import('components/Error404'))}/>
        </Switch>
    </div>
);

export default SalesSupport;



// WEBPACK FOOTER //
// ./app/routes/MasterData/routes/SalesSupport/index.js